/* eslint-disable react-hooks/exhaustive-deps */
import {setPayrollOptionsGlobal} from "store/actions/payrollAction";
import {apiGetAccountingTypes} from "api/accountingTypeApi";
import {apiSetPayroll} from "api/payrollApi";
import {apiPersonsList} from "api/personApi";
import {apiGetProjects} from "api/projectApi";
import Price from "components/Table2/CellComps/Price";
import Select from "components/Table2/CellComps/Select";
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import shortid from "shortid";

export default function usePayrollData() {
    const dispatch = useDispatch();
    const {token} = useSelector((state: any) => state).businessReducer.business;
    const {personnel} = useSelector((state: any) => state).personReducer;
    const {projects} = useSelector((state: any) => state).projectReducer;
    const {options} = useSelector((state: any) => state).payrollReducer;
    const [payrollOptions, setPayrollOptions] = useState<PayrollOption[]>(options);
    const [rows, setRows] = useState<PayrollRow[]>([]);
    const [specs, setSpecs] = useState<Specifications>();
    const tableOptions = payrollOptions ? payrollOptions.filter((x) => x.last && x.active) : [];
    const [count, setCount] = useState(0);
    const [prefOpen, setPrefOpen] = useState(false);

    useEffect(() => {
//if (!payrollOptions || payrollOptions.length === 0) {
            dispatch(
                // @ts-ignore
                apiGetAccountingTypes(token, "all", (data: any, type: string) => {
                    setPayrollOptions([]);
                    const costs = getPayrollOptions({
                        data: data.childs[6],
                        options: {isCreditor: false, tabKey: 1},
                    }).map((x) => {
                        const actives: any[] = [122, 123, 124, 125, 126, 128, 129];
                        if (actives.includes(x.id)) x.active = true;
                        return x;
                    });
                    let deductions = getPayrollOptions({data: data, options: {isCreditor: true, tabKey: 2}}).map(
                        (x) => {
                            if (x.id === undefined) x.id = "main";
                            if (x.parentId === null) x.parentId = "main";
                            const actives: any[] = [113, 97];
                            if (actives.includes(x.id)) x.active = true;
                            x.isCreditor = true;
                            return x;
                        }
                    );
                    deductions.push({
                        id: "workerInsurance",
                        parentId: "main",
                        title: "بیمه سهم کارگر",
                        active: true,
                        isCreditor: true,
                        last: true,
                        tabKey: 2,
                    });
                    const salaryItems = costs
                        .filter((x) => x.id === 132)
                        .map((x) => ({...x, parentId: null, tabKey: 3, active: true}));

                    setPayrollOptions(costs.concat(deductions).concat(salaryItems));
                })
            );
        //}

        // @ts-ignore
        dispatch(apiGetProjects(token));
        // @ts-ignore
        dispatch(apiPersonsList(token, "personnel"));
        if (rows.length === 0) initRows();
        reRender();
    }, [token]);

    useEffect(() => setSpecs((specs) => projects && {...specs, projects}), [projects]);

    const reRender = () => setCount((count) => count + 1);

    function initRows() {
        let arr: any[] = [];
        for (let index = 0; index < 5; index++) {
            arr.push({ind: shortid.generate()});
        }
        setRows(arr);
    }

    interface GetPayrollOptionsProps {
        data: any;
        arr?: any[];
        options?: { isCreditor?: boolean; tabKey?: string | number };
    }

    function getPayrollOptions({data, arr, options}: GetPayrollOptionsProps) {
        if (!data) return [];
        const {title, id, parentId} = data;
        if (!arr) arr = [];
        let childs = data.childs;
        const hasChild = childs && childs.length > 0;
        const active = false;
        let res: PayrollOption = {title, id, parentId, last: !hasChild, active, ...options};
        arr.push(res);
        if (hasChild) childs.map((x: any) => getPayrollOptions({data: x, arr, options}));
        return arr;
    }

    function handleChange(item: StringObj, options?: any) {
        let newRows = [...rows];
        let ind = options && options.row && options.row.ind;
        const index = newRows.findIndex((x) => x.ind === ind);
        const sameItems = newRows.filter(({id, ind}) => {
            return !!id && id === item.id && ind !== item.ind;
        });
        const exist = sameItems.length > 0;
        if (index >= 0 && !exist && !!item.id) newRows[index] = item as PayrollRow;
        setRows(newRows);
    }

    function handleDelete(row: any) {
        let ind = row && row.ind;
        let newRows = [...rows];
        newRows = newRows.filter((x) => x.ind !== ind);
        setRows(newRows);
        reRender();
    }

    function handleSubmit() {
        const normalizeToApi = {
            data: {
                accounting: {
                    description: specs?.description,
                    date: specs?.date,
                    projectId: specs?.project,
                    year:specs?.year,
                    month:specs?.month
                },
                rows: rows
                    .filter((x) => x.id)
                    .map((x) => {
                        let accountingItems: any[] = [];
                        for (const key in x) {
                            if (!["ind", "personnel", "id"].includes(key) && x[key]) {
                                const option = payrollOptions.find((y) => {
                                    const id = y.id;
                                    let k: number | string = key;
                                    if (typeof id === "number") k = parseInt(key);
                                    return id === k && y.active;
                                });
                                let amount = x[key];
                                let accountTypeId = parseInt(key);
                                if (key === "workerInsurance") {
                                    amount = x[132] + amount;
                                    accountTypeId = 117;
                                }
                                accountingItems.push({
                                    amount,
                                    isCreditor: option ? option.isCreditor : false,
                                    accountTypeId,
                                });
                            }
                        }
                        return {
                            personId: x.id,
                            accountingItems,
                        };
                    }),
            },
        };
        const options = {
            payroll: normalizeToApi,
            token,
            callBack: () => {
                setSpecs((specs) => ({
                    ...specs,
                    date: "",
                    description: "",
                    project: "",
                    year:'',
                    month:''
                }));
                initRows();
                reRender();
            },
        };
        // @ts-ignore
        dispatch(apiSetPayroll(options));
    }

    function handleSpecs(specs?: Specifications) {
        setSpecs(specs);
    }

    function handleAddRow() {
        setRows((rows) => [...rows, {ind: shortid.generate()} as PayrollRow]);
        reRender();
    }

    const preferences: Preferences = {
        items: payrollOptions,
        tabs: [{label: "هزینه ها"}, {label: "کسورات"}, {label: "آیتم های حقوق"}],
        open: prefOpen,
        setOpen: (x) => setPrefOpen(x),
        onChange: (items) => {
            setPayrollOptions(items);
            dispatch(setPayrollOptionsGlobal(items));
            reRender();
        },
    };

    const data: { rows: any; headers: TableHeader[]; cols: TableCol[]; specs: any } = {
        specs,
        rows,
        headers: [
            {label: "کارمند", style: {minWidth: "150px", right: "45px"}, fixRight: true},
            ...tableOptions.map(({title, active}) => ({
                label: title,
                active,
                style: {minWidth: "150px", width: "150px"},
            })),
        ],
        cols: [
            {
                Comp: Select,
                key: "personnel",
                data: {
                    options: personnel,
                },
                options: {
                    onChange: (item: any, options: any) => {
                        if (!item || !options || !options.row) return reRender();
                        if (rows.find((x) => x.id === item.id)) return reRender();
                        let res = {...options.row};
                        res.personnel = item;
                        res.id = item.id;
                        handleChange(res, {row: options.row});
                    },
                },
                fixRight: true,
                style: {right: "45px"},
            },
            ...tableOptions.map(({id, active}) => ({
                Comp: Price,
                key: id,
                active,
                options: {editable: true},
            })),
        ],
    };
    return {data, count, handleChange, handleDelete, handleAddRow, handleSubmit, handleSpecs, preferences};
}
